import React, { useContext } from "react";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { IconButton } from "@material-ui/core";
import { Cases, DELETE_CONFIRM, SinglePage } from "../../../constant";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import { Close } from "@material-ui/icons";
import { Col, Container, Input, Label, Row } from "reactstrap";
import Dividers from "../../../common/divider";
import { UploadCloud } from "react-feather";
import ProductImageUploadPopup from "../../../Modals/imageUploade/productImageUploadPopup";
import ItemsDragAndDrops from "../../../common/ItemsDragAndDrops";
import SliderContext from "../../../context/SliderContext/SliderContext";
import {
  deleteSlider,
  delete_Image_Permanent,
  sort_order_slider,
} from "../../../apis/SliderApi/SliderApi";
import { splitPathWeb } from "../../../apiConstants";
import { maxLengthCheck } from "../../../../utils/helper";
import AddNewButton from "../../../common/AddNewButton";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { singlePageSliderLimit } from "../../../../constant";

const SliderPopup = (props) => {
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const {
    handleChangeStatus,
    getData,
    handleEdit,
    imageUpload,
    emptyData,
    simpleValidator,
    webMasterDetail,
  } = props;
  const {
    apiData,
    setApiData,
    fromData,
    setFormData,
    isEdit,
    setFilter,
    filter,
  } = useContext(SliderContext);
  const { setLoaderShow } = useContext(LoaderContext);

  /**
   * drag and drop
   * @param {drag value} result
   * @returns
   */
  const handleOnDragEnd = async (result) => {
    if (!result.destination) return;
    const items = Array.from(apiData.data);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setApiData({ ...apiData, data: items });
    try {
      let itemOrder = [];
      for (const item in items) {
        itemOrder.push({ sliderId: items[item].Id, order: +item + 1 });
      }
      const { data } = await sort_order_slider(itemOrder);
      if (data.status === 200) {
        TostMessage({ message: data, type: "success" });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    }
  };

  /**
   * input value change
   * @param {Event} e
   */
  const changeFormValue = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  /**
   * delete slider
   * @param {Id} sliderId
   */
  const handleDelete = async (sliderId) => {
    let conformation = window.confirm(DELETE_CONFIRM);
    try {
      if (conformation) {
        setLoaderShow(true);
        const { data } = await deleteSlider(sliderId);
        if (data.status === 200) {
          getData();
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  /**
   * new slider create
   */
  const hanldenewCreate = () => {
    emptyData();
  };

  /**
   * image reupload
   */
  const reupload = () => {
    setFormData((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };

  /**
   * permanently delete image
   */
  const deleteImagePermanent = async () => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData = {
          fileName: fromData.image
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER}/`)
            .pop(),
        };
        const { data } = await delete_Image_Permanent(formData);
        if (data.status === 200) {
          TostMessage({ message: data, type: "success", position: "center" });
          setFormData({ ...fromData, image: "" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="6">
            <div>
              <h6>{apiData?.data?.length} Slider</h6>
              <p className="pt-2">You can add upto 6 Images</p>
              <Row>
                <Col md="6">
                  <Input
                    className="form-control mt-3 "
                    name="search"
                    type="text"
                    placeholder="search"
                    style={{ borderRadius: "0", color: "black" }}
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  />
                </Col>
                {webMasterDetail?.webCategory?.name ===
                  SinglePage.WebCategory &&
                  apiData?.data?.length !== singlePageSliderLimit && (
                    <Col
                      md="6"
                      className="d-flex justify-content-center align-items-center mt-3"
                    >
                      <AddNewButton click={() => hanldenewCreate()} />
                    </Col>
                  )}
              </Row>
              {apiData.isLoading ? (
                <div className="mt-4">
                  <h6>Loading ...</h6>
                </div>
              ) : (
                <div className="mt-4">
                  <ItemsDragAndDrops
                    handleOnDragEnd={handleOnDragEnd}
                    characters={apiData?.data}
                    handleChangeStatus={handleChangeStatus}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                  />
                </div>
              )}
            </div>
          </Col>
          {(webMasterDetail?.webCategory?.name === SinglePage.WebCategory &&
            apiData?.data?.length === singlePageSliderLimit &&
            isEdit) ||
            (webMasterDetail?.webCategory?.name === SinglePage.WebCategory &&
              apiData?.data?.length !== singlePageSliderLimit) ? (
            <Col sm="12" xl="6">
              <div className="mt-4">
                <h6>{isEdit ? "Edit" : "Add New"}</h6>
                <Row className="mt-4">
                  <Col md="12 mb-1">
                    <Label htmlFor="validationCustom03">{"Title *"}</Label>
                    <Input
                      className="form-control"
                      name="title"
                      type="text"
                      placeholder="Title *"
                      style={{ borderRadius: "0", color: "black" }}
                      value={fromData.title}
                      onChange={(e) => changeFormValue(e)}
                      min={0}
                      maxLength={50}
                      onInput={maxLengthCheck}
                    />
                    <div className="text-end mt-3 ">
                      <span>{fromData.title.length} / 50</span>
                    </div>
                    <p style={{ color: "red" }}>
                      {simpleValidator.current.message(
                        "title",
                        fromData.title,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col md="12 mb-1">
                    <Label htmlFor="validationCustom03">{"Description"}</Label>
                    <textarea
                      className="form-control"
                      name="description"
                      type="text"
                      rows={5}
                      placeholder="Description"
                      style={{ borderRadius: "0", color: "black" }}
                      value={fromData.description}
                      onChange={(e) => changeFormValue(e)}
                    />
                    <div className="text-end mt-3 ">
                      <span>{fromData?.description?.length}</span>
                    </div>
                  </Col>
                </Row>
                <Dividers divide="IMAGE *" />
                <p className="mb-4">
                  File type required JPG, PNG (1633px X 672px)
                </p>
                <Row>
                  <Col md="6 mb-3">
                    <div
                      className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                      style={{ cursor: "pointer" }}
                    >
                      {!fromData?.image && (
                        <span
                          onClick={() =>
                            OpenModalCommonFunc(
                              Cases.PRODUCT_UPLOAD,
                              setAllPopupState
                            )
                          }
                        >
                          <UploadCloud />
                        </span>
                      )}

                      {fromData?.image && (
                        <img
                          src={fromData?.image ? fromData?.image : ""}
                          alt=""
                          style={{
                            width: "80%",
                            height: "98%",
                            objectFit: "contain",
                            position: "absolute",
                          }}
                          onClick={() => deleteImagePermanent()}
                        />
                      )}
                      {fromData.image && (
                        <IconButton
                          edge="start"
                          color="inherit"
                          aria-label="close"
                          style={{
                            color: "red",
                            position: "absolute",
                            top: "-22px",
                            left: "1px",
                          }}
                          onClick={() => deleteImagePermanent()}
                        >
                          <Close
                            style={{ fontSize: "25px", fontWeight: "bold" }}
                          />
                        </IconButton>
                      )}
                    </div>
                    <p style={{ color: "red" }}>
                      {simpleValidator.current.message(
                        "image",
                        fromData.image,
                        "required"
                      )}
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          ) : (
            ""
          )}
        </Row>
        <ProductImageUploadPopup
          allPopupState={allPopupState}
          setAllPopupState={setAllPopupState}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          image={fromData.image}
          setImage={setFormData}
          imageUpload={imageUpload}
          isEdit={isEdit}
          reupload={reupload}
          aspect={2.42 / 1}
        />
      </Container>
    </>
  );
};

export default SliderPopup;
